import * as React from 'react';
const SecchezzaVaginaleIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-1{fill-rule:evenodd;stroke:${primaryColor ||
        '#282828'}}.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'}}`}</style>
    </defs>
    <path
      d="M60.06 139.03c-.61-2.88-1.21-5.98-1.81-9.5-5.96-35.18 4.93-41.62 12.38-68.56M139.94 139.03c.61-2.88 1.21-5.98 1.81-9.5 5.96-35.18-4.93-41.62-12.38-68.56M96.3 131.39c.07 2.54 0 5.09-.16 7.64M103.85 139.03c-.16-2.55-.23-5.1-.16-7.64"
      className="prefix__cls-1"
    />
    <path
      d="M76.6 92.58c-4.59-1.91-9.43-4.35-14.69-7.3M138.09 85.28c-5.44 3.06-10.45 5.57-15.19 7.51M73.91 102.92c-4.77-2.56-9.98-4.69-15.45-6.33M141.52 96.59c-5.48 1.64-10.69 3.77-15.46 6.33"
      className="prefix__cls-1"
    />
    <path
      d="m97.3 108.6 5.4-6.3 5.4 1.8v4.5l2.69 3.6-1.79 5.39-6.3-2.69-4.5.89.9-3.59zM87.41 120.29l7.19-.9 3.6-3.6M97.3 108.6l-4.5-3.6H91l-4.49 3.6-3.6 5.4M91 105l-1.79-2.7 4.49-3.6 8.1.9.9 2.7M103.6 86.11l-3.6 6.3 1.8 7.19"
      className="prefix__cls-2"
    />
    <path
      d="m108.1 104.1 2.69-2.7.9-2.7-.9-2.69-.9-8.1M93.7 98.7l-.9-4.49 7.2-1.8M80.21 105l9-2.7-2.7-5.4.9-3.59 5.39.9M117.99 96.9l-2.7 1.8h-3.6M110.79 112.2l9-7.2M109 117.59l3.59 2.7M94.6 119.39l.9 4.5M87.41 93.31l-.9-2.7"
      className="prefix__cls-2"
    />
    <circle cx={100} cy={105} r={19.79} className="prefix__cls-2" />
  </svg>
);
export default SecchezzaVaginaleIcon;
